import React, { useState, useEffect } from 'react';
import successBubble from '../../assets/icons/common/success-bubble.svg';
import './Toast.css';

const Toast = ({ success, error, setSuccess, setError, className = "" }) => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const removeToast = id => {
      setToasts(currentToasts => currentToasts.filter(toast => toast.id !== id));
    };

    const showToast = (message, type) => {
      const id = new Date().getTime();
      setToasts([...toasts, { id, message, type, show: true }]);

      // Remove the toast after 5 seconds
      setTimeout(() => {
        removeToast(id);
      }, 5000);
    };

    if (success) {
      showToast(success, 'success');
      setSuccess(null); // Clear the success message after displaying
    }
    if (error) {
      showToast(error, 'danger');
      setError(null); // Clear the error message after displaying
    }
  }, [success, error, setSuccess, setError]);

  return (
    <>
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`toast toast-container ${toast.show ? 'show' : ''} ${toast.type} ${className}`}
          role="alert"
          style={{bottom: document.getElementById("toastNoSite") ? '140px' : '16px'}}
          aria-live="assertive"
          aria-atomic="true"
          onClick={() => setToasts(toasts => toasts.filter(t => t.id !== toast.id))}
        >
          <div className="toast-body" id={toast.type === 'danger' ? 'errorMessage' : 'successMessage'}>
            {toast.type === 'success' && <img src={successBubble} alt="Success" className="toast-icon" />}
            {toast.message}
          </div>
          <button type="button" className="btn-close" onClick={() => setToasts(toasts => toasts.filter(t => t.id !== toast.id))}></button>
        </div>
      ))}
    </>
  );
};

export default Toast;
